@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.arrow-buttons {
  display: flex;
  flex-direction: column;
  background-color: @number-input-arrow-button-group--background-color;

  &.disabled {
    background-color: @number-input-arrow-button-group--disabled--background-color;
  }

  .arrow-button {
    padding: 0;
    margin: 0;
    border: none;
    width: 20px;
    height: 100%;
    background: none;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    &:first-child {
      padding-top: 20%;
    }

    &:last-child {
      padding-bottom: 20%;
    }

    &:disabled {
      cursor: default;
      opacity: 0.6;
    }

    &:hover,
    &:focus {
      outline: none;
      background: @number-input-arrow-button-group--focus--background-color;
      cursor: pointer;

      svg {
        color: @number-input-arrow-button-group--focus--fill-color;
      }
      &:disabled {
        cursor: default;
        svg {
          color: @number-input-arrow-button-group--focus--disabled--fill-color;
        }
      }
    }

    svg {
      color: @number-input-arrow-button-group--fill-color;
      min-width: 6.5px;
      height: 11px;
      min-height: 5px;
    }
  }
}
